<div class="flex flex-col h-full w-full justify-start items-start bg-white">
  <div class="flex flex-col h-full w-full justify-start items-start gap-6 p-6 overflow-hidden">
    @if (loading) {
      <div class="flex w-full h-full items-center justify-center">
        <fa-icon [icon]="faSpinnerThird" class="text-3xl text-gray-400 animate-spin"></fa-icon>
      </div>
    } @else {
      <app-files
        [(selectedFiles)]="selectedFiles"
        [backButtonActivated]="false"
        [calledFromCheck]="true"
        [customFilesActivated]="true"
        [customFiles]="files"
        [filterAndContextButtonActivated]="false"
        [noOuterPadding]="true"
        class="flex w-full h-full">
      </app-files>
    }

    <div class="flex flex-row w-full justify-center items-center">
      <bic-button (click)="confirm()"
                  [disabled]="selectedFiles.length === 0"
                  [loading]="confirming">
        Weiter
        <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
      </bic-button>
    </div>
  </div>
</div>
